import '../styles/TimelineNavigation.scss';

import { CSSProperties, useMemo } from 'react';

import { cn } from '../../../helpers/classBuilders';
import { useClassHelper } from '../../../hooks';

const componentName = 'c-TimelineNavigationSlider';

interface Props {
  currentPage: string;
  currentPageIndex: number;
  goTo: (key: string) => void;
  pages: string[];
  preludePage: boolean;
  preludePageKey: string;
  totalPages: number;
}

export function TimelineNavigation({
  pages,
  preludePageKey,
  currentPageIndex,
  currentPage,
  preludePage,
  goTo,
}: Props) {
  const c = useClassHelper(componentName);

  const filteredPages = useMemo(() => {
    return pages.filter(page => page !== preludePageKey);
  }, [preludePageKey]);

  if (preludePage) {
    return null;
  }

  const styles = {
    '--total-progress':
      (100 / (filteredPages.length - 1)) * (currentPageIndex - 1),
  } as CSSProperties;

  return (
    <div
      className={componentName}
      style={styles}
      role="tablist"
      aria-label="Timeline Navigation"
    >
      {filteredPages.map((page, index) => {
        const active = page === currentPage;
        return (
          <div
            role="tab"
            key={page}
            className={c('__entry', {
              '__entry--visited': currentPageIndex > index,
              '__entry--active': active,
            })}
            aria-selected={active}
            tabIndex={0}
            onClick={() => goTo(page)}
          >
            <span
              role="button"
              className={cn(
                'text-xs text-gray-500 block text-center whitespace-nowrap absolute top-[10px] capitalize focus-visible:focus-ring hover:text-gray-900',
                {
                  'text-gray-800 font-bold': active || currentPageIndex > index,
                },
              )}
            >
              {page}
            </span>
          </div>
        );
      })}
    </div>
  );
}
